import { Box, Center, Flex, Skeleton, SkeletonProps, Space, Stack, Text as MantineText } from '@mantine/core';
import { IconBell } from '@tabler/icons';
import { FC } from 'react';
import EmptyListState from '../Molecules/EmptyListState';
import EmptyText from './EmptyText';
import BookitupAddIcon from './BookitupAddIcon';

interface Props extends SkeletonProps {
  count?: number;
}

const SkeletonItems: FC<Props> = ({ count = 3, ...rest }) => (
  <div>
    {Array.from(Array(count)).map(() => (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <Skeleton key={Math.random()} radius="md" height={25} width="100%" mb={10} {...rest} />
    ))}
  </div>
);

export const NotificationSkeletonItems = () => (
  <Stack mt="xs">
    {Array.from(Array(4)).map(() => (
      // eslint-disable-next-line react/jsx-key
      <Flex gap="md" sx={{ maxWidth: 400 }}>
        <Skeleton circle height={40} sx={{ minWidth: 40 }} />
        <Skeleton height={50} />
      </Flex>
    ))}
  </Stack>
);

export const EmptyListSkeleton = () => (
  <Stack spacing="xs" p={5}>
    {Array.from(Array(5)).map(() => (
      // eslint-disable-next-line react/jsx-key
      <Box
        sx={(theme) => ({
          width: '100%',
          height: 80,
          backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
          borderRadius: 10,
        })}
      />
    ))}
    <MantineText italic color="dimmed" align="center" mb="xl" mt="xl">
      keine Emails
    </MantineText>
  </Stack>
);

export const EmptyPositionsSkeleton = () => (
  <Stack mb="md">
    <Box
      mt={5}
      sx={(theme) => ({
        width: '100%',
        height: 50,
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
        borderRadius: 10,
      })}
    />
    <Box
      sx={(theme) => ({
        width: '100%',
        height: 100,
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
        borderRadius: 10,
      })}
    />
    <EmptyText mt={-5} align="center" weight="bolder" />
  </Stack>
);

export const EmptyProductsSkeleton: FC<{ onClick: () => void }> = ({ onClick }) => (
  <Stack mt="xs">
    <Box
      sx={(theme) => ({
        width: '100%',
        height: 50,
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
        borderRadius: 10,
      })}
    />
    <Box
      sx={(theme) => ({
        width: '100%',
        height: 100,
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
        borderRadius: 10,
      })}
    />
    <MantineText sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
      Du hast noch keine vordefinierten Positionen. Klicke auf
      <Space w={5} />
      <BookitupAddIcon onClick={onClick} />
      <Space w={2} />, um eine anzulegen.
    </MantineText>
  </Stack>
);

export const EventItemSkeleton = () => (
  <Center>
    <Skeleton height={100} width={800} />
  </Center>
);

export const QuestionBundleSkeleton = () => (
  <Stack mt="md">
    <Box
      sx={(theme) => ({
        width: '100%',
        height: 80,
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
        borderRadius: 10,
      })}
    />
    <Box
      sx={(theme) => ({
        width: '100%',
        height: 80,
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
        borderRadius: 10,
      })}
    />
    <EmptyText align="center" weight="bolder" />
  </Stack>
);

export default SkeletonItems;

export const NotificationsEmptyListSkeleton = () => (
  <EmptyListState icon={<IconBell size={30} stroke={1.6} />} title="Keine Benachrichtigungen">
    Du hast aktuell keine Benachrichtigungen.
  </EmptyListState>
);
